import { render, staticRenderFns } from "./giveawayRejectRefundModal.vue?vue&type=template&id=31e019a1&scoped=true"
import script from "./giveawayRejectRefundModal.vue?vue&type=script&lang=ts"
export * from "./giveawayRejectRefundModal.vue?vue&type=script&lang=ts"
import style0 from "./giveawayRejectRefundModal.vue?vue&type=style&index=0&id=31e019a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e019a1",
  null
  
)

export default component.exports